// extracted by mini-css-extract-plugin
export default {"processImages":"ProductImages_processImages__mH6Lq","processImage":"ProductImages_processImage__ojVxw"};